module.exports = __webpack_public_path__ + "static/media/subICloud3.aed2d110.png";